import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  CibusCallLogsPage,
  CibusCallLogsQuery,
  CibusMenuExportView,
  CibusTestLoginResult,
  CibusTestPosWsResult,
  UpdateCibusTenantConfigRequest,
} from 'shared-models/browser';

export type {
  CibusCallDirection,
  CibusMenuExportView,
  CibusCallKind,
  CibusCallLogView,
  CibusCallLogsPage,
  CibusCallLogsQuery,
  CibusCallStatus,
  CibusTestLoginResult,
  CibusTestPosWsResult,
  UpdateCibusTenantConfigRequest,
} from 'shared-models/browser';

class AdminCibusService {
  async list(query: CibusCallLogsQuery = {}): Promise<CibusCallLogsPage> {
    try {
      const response = await authenticatedInstance.get<CibusCallLogsPage>('/cibus/call-logs', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת מעקב סיבוס נכשלה'));
    }
  }

  // Diff-only; the caller sends only changed fields, an empty diff never reaches here.
  async updateTenantConfig(tenantIdPk: number, payload: UpdateCibusTenantConfigRequest): Promise<void> {
    try {
      await authenticatedInstance.patch<void>(`/cibus/tenants/${tenantIdPk}/config`, payload);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון הגדרות סיבוס נכשל'));
    }
  }

  async testLogin(tenantIdPk: number): Promise<CibusTestLoginResult> {
    try {
      const response = await authenticatedInstance.post<CibusTestLoginResult>(`/cibus/tenants/${tenantIdPk}/test-login`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'בדיקת ההתחברות לסיבוס נכשלה'));
    }
  }

  async testPosWs(tenantIdPk: number): Promise<CibusTestPosWsResult> {
    try {
      const response = await authenticatedInstance.post<CibusTestPosWsResult>(`/cibus/tenants/${tenantIdPk}/test-posws`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'בדיקת סליקת סיבוס נכשלה'));
    }
  }

  async exportMenu(tenantIdPk: number): Promise<CibusMenuExportView> {
    try {
      const response = await authenticatedInstance.get<CibusMenuExportView>(`/cibus/tenants/${tenantIdPk}/menu-export`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ייצוא תפריט סיבוס נכשל'));
    }
  }

  async disconnect(tenantIdPk: number): Promise<void> {
    try {
      await authenticatedInstance.post<void>(`/cibus/tenants/${tenantIdPk}/disconnect`);
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'ניתוק סיבוס נכשל'));
    }
  }
}

export const adminCibusService = new AdminCibusService();
